import Vue from 'vue';

Vue.config.devtools = true
const mutations = {
  setCanderProduct(state, payload) {
    state.canderProduct = Object.assign(state.canderProduct, payload);
  },
  setMainProducts(state, payload) {
    state.mainProducts = payload;
  },
  setAddonProducts(state, payload) {
    state.addonProducts = payload;
  },
  setCardProducts(state, payload) {
    state.cardProducts = payload;
  },
  updateSelectedMainProduct(state, payload) {
    state.selectedMainProduct = payload;
  },
  updateSelectedCardProduct(state,payload){
    Vue.set(state, 'selectedCardProduct', null);
    Vue.set(state, 'selectedCardProduct', payload);
  },
  updateSavedCardProduct(state,payload){
    state.savedCardProduct = payload;
  },
  updateSavedKey(state,payload){
    state.savedKey = payload;
  },
  //NEW MUTATIONS
  setMaxCapacity(state, payload) {
    state.maxCapacity = payload;
  },
  setCuratedBoxes(state, payload){
    state.curatedBoxes = payload;
  },
  updateAllSelectedAddonProducts(state,payload){
    Vue.set(state, 'selectedAddonProducts', payload);
  },
  updateSelectedAddonProductsNew(state, payload) {
    let product = payload.product;
    let quantity = payload.quantity;
    let currentIndex = state.selectedAddonProducts.findIndex(x => x.variants[0].id == product.variants[0].id);
    if(currentIndex > -1 && quantity > 0){
      state.selectedAddonProducts[currentIndex].quantity = quantity;
    }
    else if(currentIndex > -1 && quantity == 0){
      state.selectedAddonProducts.splice(currentIndex, 1);
    }
    else if(currentIndex < 0 && quantity > 0){
      Vue.set(product, 'quantity', quantity);
      state.selectedAddonProducts.push(product);
    }
  },
  updateAddonProperties(state, payload){
    let product = payload.product;
    let properties = payload.properties;
    let currentIndex = state.selectedAddonProducts.findIndex(x => x.variants[0].id == product.variants[0].id);
    if(currentIndex > -1){
      state.selectedAddonProducts[currentIndex].properties = properties;
    }
  },
  removeSelectedAddonProductNew(state, payload) {
    let currentIndex = state.selectedAddonProducts.findIndex(x => x.id == payload.id);
    if(currentIndex > -1){
      state.selectedAddonProducts.splice(currentIndex, 1);
    }
  },
  updateIndividualAddonProducts(state, payload) {
    let product = payload.product;
    let quantity = payload.quantity;
    let currentIndex = state.selectedIndividualAddons.findIndex(x => x.variants[0].id == product.variants[0].id);
    if(currentIndex > -1 && quantity > 0){
      state.selectedIndividualAddons[currentIndex].quantity = quantity;
    }
    else if(currentIndex > -1 && quantity == 0){
      state.selectedIndividualAddons.splice(currentIndex, 1);
    }
    else if(currentIndex < 0 && quantity > 0){
      Vue.set(product, 'quantity', quantity);
      state.selectedIndividualAddons.push(product);
    }
  },
  updateIndividualAddonProperties(state, payload){
    let product = payload.product;
    let properties = payload.properties;
    let currentIndex = state.selectedIndividualAddons.findIndex(x => x.variants[0].id == product.variants[0].id);
    if(currentIndex > -1){
      state.selectedIndividualAddons[currentIndex].properties = properties;
    }
  },
  setSelectedOccasion(state,payload){
    let currentIndex = state.selectedOccasion.findIndex(x => x == payload);
    if(currentIndex > -1){
      state.selectedOccasion.splice(currentIndex, 1);
    }
    else{
      Vue.set(state,'selectedOccasion',state.selectedOccasion.concat([payload]));
    }
  },
  setAllSelectedOccasion(state,payload){
    state.selectedOccasion = payload;
  },
  setAllSelectedCategories(state,payload){
    state.selectedCategories = payload;
  },
  setSelectedCategories(state,payload){
    let currentIndex = state.selectedCategories.findIndex(x => x == payload);
    let allIndex = state.selectedCategories.findIndex(x => x == "View All");
    if(allIndex > -1 && allIndex == currentIndex){
      return
    }
    if(currentIndex > -1){
      state.selectedCategories.splice(currentIndex, 1);
    }
    else{
      if(payload == "View All"){
        state.selectedCategories = ["View All"];
      }
      else{
        Vue.set(state,'selectedCategories',state.selectedCategories.concat([payload]));
        if(allIndex > -1){
          state.selectedCategories.splice(allIndex, 1);
        }
      }
    }
    if(state.selectedCategories.length == 0){
      state.selectedCategories = ["View All"];
    }
  },
  setBoxQty(state,payload){
    Vue.set(state, 'boxQty', payload);
  },
  setSelectedSort(state,payload){
    Vue.set(state, 'selectedSort', payload);
  },
  setRangePrice(state,payload){
    Vue.set(state, 'rangePrice', payload);
  },
  setSelectedFilters(state,payload){
    let currentIndex = state.selectedFilters.findIndex(x => x.title == payload.title);
    if(currentIndex > -1){
      if(payload.filters.length > 0){
        Vue.set(state.selectedFilters[currentIndex],"filters", payload.filters);
      }
      else{
        state.selectedFilters.splice(currentIndex, 1);
      }
    }
    else{
      state.selectedFilters.push(payload);
    }
  },
  //MOBILE VARIABLES FILTER START
  setSelectedOccasionMobile(state,payload){
    let currentIndex = state.selectedOccasionMobile.findIndex(x => x == payload);
    if(currentIndex > -1){
      state.selectedOccasionMobile.splice(currentIndex, 1);
    }
    else{
      Vue.set(state,'selectedOccasionMobile',state.selectedOccasionMobile.concat([payload]));
    }
  },
  setAllSelectedOccasionMobile(state,payload){
    state.selectedOccasionMobile = payload;
  },
  setAllSelectedCardOccasion(state,payload){
    state.selectedCardsOccasions = payload;
  },
  setAllSelectedCardOccasionMobile(state,payload){
    state.selectedCardsOccasionsMobile = payload;
  },
  setSelectedCardsOccasions(state,payload){
    let currentIndex = state.selectedCardsOccasions.findIndex(x => x == payload);
    let allIndex = state.selectedCardsOccasions.findIndex(x => x == "View All");
    if(allIndex > -1 && allIndex == currentIndex)
      return
    if(currentIndex > -1){
      state.selectedCardsOccasions.splice(currentIndex, 1);
      if(state.selectedCardsOccasions.length == 0){
        state.selectedCardsOccasions = ["View All"];
      }
    }
    else{
      if(payload == "View All"){
        state.selectedCardsOccasions = ["View All"];
      }
      else{
        state.selectedCardsOccasions.push(payload);
        if(allIndex > -1){
          state.selectedCardsOccasions.splice(allIndex, 1);
        }
      }
    }
  },
  setSelectedCardsOccasionsMobile(state,payload){
    let currentIndex = state.selectedCardsOccasionsMobile.findIndex(x => x == payload);
    let allIndex = state.selectedCardsOccasionsMobile.findIndex(x => x == "View All");
    if(allIndex > -1 && allIndex == currentIndex)
      return
    if(currentIndex > -1){
      state.selectedCardsOccasionsMobile.splice(currentIndex, 1);
      if(state.selectedCardsOccasionsMobile.length == 0){
        state.selectedCardsOccasionsMobile = ["View All"];
      }
    }
    else{
      if(payload == "View All"){
        state.selectedCardsOccasionsMobile = ["View All"];
      }
      else{
        state.selectedCardsOccasionsMobile.push(payload);
        if(allIndex > -1){
          state.selectedCardsOccasionsMobile.splice(allIndex, 1);
        }
      }
    }
  },
  setAllSelectedCategoriesMobile(state,payload){
    state.selectedCategoriesMobile = payload;
  },
  setSelectedCategoriesMobile(state,payload){
    let currentIndex = state.selectedCategoriesMobile.findIndex(x => x == payload);
    let allIndex = state.selectedCategoriesMobile.findIndex(x => x == "View All");
    if(allIndex > -1 && allIndex == currentIndex){
      return
    }
    if(currentIndex > -1){
      state.selectedCategoriesMobile.splice(currentIndex, 1);
    }
    else{
      if(payload == "View All"){
        state.selectedCategoriesMobile = ["View All"];
      }
      else{
        Vue.set(state,'selectedCategoriesMobile',state.selectedCategoriesMobile.concat([payload]));
        if(allIndex > -1){
          state.selectedCategoriesMobile.splice(allIndex, 1);
        }
      }
    }
    if(state.selectedCategoriesMobile.length == 0){
      state.selectedCategoriesMobile = ["View All"];
    }
  },
  setSelectedSortMobile(state,payload){
    state.selectedSortMobile = payload;
  },
  setRangePriceMobile(state,payload){
    Vue.set(state, 'rangePriceMobile', payload);
  },
  setSelectedFiltersMobile(state,payload){
    let currentIndex = state.selectedFiltersMobile.findIndex(x => x.title == payload.title);
    if(currentIndex > -1){
      if(payload.filters.length > 0){
        Vue.set(state.selectedFiltersMobile[currentIndex], payload);
      }
      else{
        state.selectedFiltersMobile.splice(currentIndex, 1);
      }
    }
    else{
      state.selectedFiltersMobile.push(payload);
    }
  },
  setTotalSelectedFiltersMobile(state,payload){
    Vue.set(state,'selectedFiltersMobile',payload);
  },
  setTotalSelectedFilters(state,payload){
    state.selectedFilters = payload;
  },
  //MOBILE VARIABLES FILTER END
  setBoxName(state,payload){
    state.boxName = payload;
  },
  setDefaulBoxName(state,payload){
    state.defaulBoxName = payload;
  },
  setCartNames(state,payload){
    state.cartNames = payload;
    //Set default Box Name
    let boxNumber = payload.length + 1;
    var defaulBoxName = 'Box ' + boxNumber;
    while(payload.includes(defaulBoxName)){
      boxNumber++;
      defaulBoxName = 'Box ' + boxNumber;
    }
    state.defaulBoxName = defaulBoxName;
    state.boxName = defaulBoxName;
  },
  setFeeProduct(state,payload){
    state.feeProduct = payload;
  },
  setCartQty(state, payload){
    state.cartQty = payload;
  },
  setOccasions(state, payload){
    state.occasions = payload;
  },
  setCategories(state, payload){
    state.categories = payload;
  },
  setIsPage(state, payload){
    state.isPage = payload;
  },
  updateCardProperties(state, payload){
    let properties = payload.properties;
    if(state.selectedCardProduct){
      state.selectedCardProduct.properties = properties;
    }
  },
  setMultishipCallout(state, payload){
    state.multishipCallout = payload;
  },
  setCardHasMessage(state,payload){
    state.cardHasMessage = payload;
  },
  setShowCardAlert(state,payload){
    state.showCardAlert = payload;
  }
};

export default mutations;
